import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AgendaContext } from '../../../contexts/AgendaContext.jsx';
// Mui components
import { Typography, Box } from '@mui/material';
// Components
import DetailSkeleton from '../../common/DetailSkeleton.jsx';
// Modals
import ModalConfirmarAnularSolcitud from '../Modals/ModalConfirmarAnularSolicitud.jsx';
// Icons
import iconChevronLeft from '../../../assets/icons/icon_chevron-left.svg';
// ErrorProvider
import { useError } from '../../../contexts/ErrorProvider.jsx';
import DetailUserSolicitudes from './DetailUserSolicitudes.jsx';
import SeccionInfoSolicitud from './SeccionInfoSolicitud.jsx';

function DetailSolicitudes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { solicitudDetail, getInfoSolicitud, getMotivosRechazo } = useContext(AgendaContext);
  const [loader, setLoader] = useState(true);

  const { handleError } = useError();

  useEffect(() => {
    if (solicitudDetail) {
      setLoader(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      getInfoSolicitudComponentMount();
    }
  }, []);

  const getInfoSolicitudComponentMount = async () => {
    try {
      await getInfoSolicitud(id);
      getMotivosRechazo();
    } catch (error) {
      handleError({ error: error, description: 'initializeError' });
    } finally {
      setLoader(false);
    }
  };

  const [modalAnularIsVisible, setModalAnularIsVisible] = useState(false);

  const handleOpen = () => setModalAnularIsVisible(true);
  const handleClose = () => setModalAnularIsVisible(false);

  return solicitudDetail ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingBottom: '5rem',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
      <ModalConfirmarAnularSolcitud
        modalIsVisible={modalAnularIsVisible}
        solicitud={solicitudDetail}
        handleClose={handleClose}
      />
      <Box
        sx={{
          display: 'flex',
          width: '920px',
          marginTop: 'calc(3rem + 76px)',
          marginLeft: '4rem',
          height: '100%',
          flexDirection: 'column',
          gap: '2.5rem'
        }}>
        <Box
          onClick={() => navigate('/prestador/dashboard')}
          sx={{
            display: 'flex',
            gap: '1rem',
            alignItems: 'center',
            cursor: 'pointer'
          }}>
          <Box
            component="img"
            sx={{ width: '24px', height: '24px' }}
            alt="img not found"
            src={iconChevronLeft}
          />
          <Typography variant="h2"> Detalle de la solicitud</Typography>
        </Box>

        <DetailUserSolicitudes />

        <SeccionInfoSolicitud handleOpen={handleOpen} />
      </Box>
    </Box>
  ) : (
    loader && <DetailSkeleton />
  );
}

export default DetailSolicitudes;
